import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgModel } from '@angular/forms';


@Component({
  selector: 'app-visualmap',
  templateUrl: './visualmap.component.html',
  styleUrls: ['./visualmap.component.css']
})
export class VisualmapComponent implements OnInit {


  rowHeight = 50;
  selectedEvent = '';
  events = [];
  resources = [];
  timeRanges = true;
  barMargin = 5;
  startDate = new Date(2018, 1, 7, 8);
  endDate = new Date(2018, 1, 7, 22);


  constructor() { }

  ngOnInit(): void {
  }

}
